import SettingsPageContent from "components/Design/Settings/SettingsPageContent";
import React from "react";
import SettingsPage from "../../components/Design/Settings/SettingsPage";
import { Routing } from "../../data/Constants/Routing";
import { useApiStates } from "../../state/Store";
import ScenarioForm from "./ScenarioForm";

const CreateScenarioScreen: React.FC = () => {
    const api = useApiStates("roles");

    return (
        <SettingsPage
            breadcrumbs={[{
                title: "Szenarien",
                link: Routing.Administration.Scenario.Navigate()
            }]}
            title="Szenario anlegen">

            <SettingsPageContent api={api}>

                <ScenarioForm
                    availableRoles={api.roles.value ?? []}
                    scenario={undefined} />

            </SettingsPageContent>

        </SettingsPage>
    );
};

export default CreateScenarioScreen;
